module.exports = __webpack_public_path__ + "static/komal-2bf1c2fbb2184fe2b1b3176372b28b5a.jpg";